
 /**
    1-9 万
    11-19 条
    21-29 筒
    
    31-37 东南西北中发白
*/




export class TouchCardChallengeDataManage {
    
    
    
}